import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import { configureAmplify } from '@/config/amplify';
import { reloadForNewVersion } from '@/utils/chunkError';

// Amplify初期化（アプリ起動時に1回だけ実行）
configureAmplify();

// 動的 import の依存チャンクの読み込みに失敗したときに Vite が投げるイベント。
// デプロイをまたいで開きっぱなしのタブは古い index.html を握っているため、
// 消えた旧ハッシュのファイルを取りに行って失敗する。1回だけ自動でリロードして
// 新しい index.html を取り直す（レンダー中に起きた分は AppErrorBoundary が拾う）。
window.addEventListener('vite:preloadError', () => {
  reloadForNewVersion();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
